import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      {isMenuOpen && <div className="nav-overlay" onClick={() => setIsMenuOpen(false)} />}
      <div className="header-container">
        <div className="logo">
          <svg width="48" height="36" viewBox="0 0 100 60" className="flag-icon">
            {/* Orange band with wave */}
            <path d="M 10 10 Q 30 5 50 10 T 90 10 L 90 25 Q 70 30 50 25 T 10 25 Z" fill="#FF9933" />
            
            {/* White band with wave */}
            <path d="M 10 25 Q 30 20 50 25 T 90 25 L 90 40 Q 70 45 50 40 T 10 40 Z" fill="#FFFFFF" />
            
            {/* Green band with wave */}
            <path d="M 10 40 Q 30 35 50 40 T 90 40 L 90 55 Q 70 60 50 55 T 10 55 Z" fill="#138808" />
            
            {/* Ashoka Chakra */}
            <circle cx="50" cy="32.5" r="6" fill="none" stroke="#000080" strokeWidth="1.2" />
            <g stroke="#000080" strokeWidth="0.8" fill="none">
              <line x1="50" y1="26.5" x2="50" y2="38.5" />
              <line x1="44" y1="32.5" x2="56" y2="32.5" />
              <line x1="45.5" y1="28" x2="54.5" y2="37" />
              <line x1="54.5" y1="28" x2="45.5" y2="37" />
            </g>
            
            {/* Chakra spokes */}
            <g stroke="#000080" strokeWidth="0.6" fill="none">
              <line x1="50" y1="26" x2="50" y2="39" />
              <line x1="44.5" y1="32.5" x2="55.5" y2="32.5" />
              <line x1="46.5" y1="27.5" x2="53.5" y2="37.5" />
              <line x1="53.5" y1="27.5" x2="46.5" y2="37.5" />
            </g>
          </svg>
          <h1>Software Developer</h1>
        </div>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>

        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
            <li><a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>Features</a></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
          </ul>
        </nav>
        
        <div className="contact-info">
          <a href="https://wa.me/918826360188" target="_blank" rel="noopener noreferrer" className="contact-link">
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fill="#25D366" d="M12.04 2C6.48 2 2 6.48 2 12.04c0 1.54.36 3.01 1 4.31L2 22l5.07-1.33A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12.04 2z"/>
              <path fill="#ffffff" d="M16.31 15.36c-.28-.14-1.66-.82-1.92-.92-.26-.1-.44-.14-.63.14s-.72.92-.88 1.11c-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.15-1.32-.8-.7-1.34-1.58-1.5-1.85-.16-.27-.02-.42.12-.56.12-.12.27-.31.41-.47.14-.15.18-.26.28-.43.1-.16.05-.3-.02-.44-.07-.14-.63-1.52-.86-2.08-.23-.55-.47-.48-.63-.49-.16-.01-.35-.01-.54-.01s-.44.06-.67.31c-.23.25-.88.86-.88 2.09 0 1.23.9 2.42 1.02 2.59.12.18 1.77 2.7 4.3 3.79 1.92.85 2.74.9 2.99.85.25-.05.84-.33.96-.65.12-.31.12-.58.08-.65-.05-.07-.18-.12-.38-.21z"/>
            </svg>
            <span>+91 8826360188</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
